function showVideo(o){
    $(".ui-dialog").remove();
    if($("body").width()<768) return true;

    var player = '<div class="yt-popup" style="text-align: center; overflow: hidden;"><iframe width="{w}" height="{h}" src="https://www.youtube.com/embed/{id}?rel=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe></div>';

    player = player.replace("{id}", $(o).attr("yt-data"));

    //1.78
    var w=0;
    var pads=50;

    if($("body").width()>=1500) w=1000;
    else if($("body").width()>=1220) w=800
    else if($("body").width()>=960) w=600;

    player = player.replace("{w}", (w)-pads);
    player = player.replace("{h}", (w/1.78)-pads);

    //$(".yt-popup").remove();
    //$("body").append(player);

    $(player).dialog({
        modal: true,
        width: w,
        title: $(".title > .text", o).text(),
        close: function(){
            $(".ui-dialog").remove();
        }
    });

    return false;
}